import React from 'react';
import { useTranslation } from 'react-i18next';
import { Activity, User } from 'lucide-react';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

const getActionBadge = (action, resultat) => (
  <Badge variant={resultat === 'SUCCESS' ? 'default' : 'destructive'}>{action}</Badge>
);

const SecurityAuditAccordionItem = ({ auditLogs }) => {
  const { t } = useTranslation();

  return (
    <AccordionItem value="audit">
      <AccordionTrigger>
        <div className="flex items-center space-x-2">
          <Activity className="h-4 w-4" />
          <span>{t('security.audit.sectionTitle')}</span>
          <Badge variant="secondary">{auditLogs.length}</Badge>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <Card>
          <CardContent className="p-6">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t('security.audit.user')}</TableHead>
                  <TableHead>{t('security.audit.action')}</TableHead>
                  <TableHead>{t('security.audit.module')}</TableHead>
                  <TableHead>{t('security.audit.dateTime')}</TableHead>
                  <TableHead>{t('security.audit.ipAddress')}</TableHead>
                  <TableHead>{t('security.audit.result')}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {auditLogs.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell>
                      <div className="flex items-center space-x-2">
                        <User className="h-4 w-4" />
                        <span>{log.user}</span>
                      </div>
                    </TableCell>
                    <TableCell>{getActionBadge(log.action, log.resultat)}</TableCell>
                    <TableCell><Badge variant="outline">{log.module}</Badge></TableCell>
                    <TableCell>{new Date(log.timestamp).toLocaleString()}</TableCell>
                    <TableCell>
                      <code className="text-xs bg-muted px-1 rounded">{log.ip_address}</code>
                    </TableCell>
                    <TableCell>
                      {log.resultat === 'SUCCESS' ? (
                        <Badge variant="default" className="bg-green-600">{t('security.audit.success')}</Badge>
                      ) : (
                        <Badge variant="destructive">{t('security.audit.failure')}</Badge>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </AccordionContent>
    </AccordionItem>
  );
};

export default SecurityAuditAccordionItem;
